/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { createSlice, PayloadAction, Action } from '@reduxjs/toolkit';
import {
    CompanyInfo,
    ClientFormState,
    StarterInfo,
    ClientDocuments,
} from '../../types';

const initialState: ClientFormState = {
    role: 'client',
    UUID: '',
    status: 'IN_PROGRESS',
    starterInfo: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        smsOptIn: false,
    },
    client: {
        totalSteps: 4,
        companyInfo: {
            name: '',
            website: '',
            doingBusinessAs: '',
            corporationType: '',
            companyAddress: {
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
            },
            billingAddress: {
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
            },
            useCompanyAddressAsBilling: true,
            useNameAsDBA: true,
            headquarteredInCalifornia: undefined,
        },
        accountsPayableRepresentative: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
        },
        documents: {
            w9: [],
        },
    },
};

// type SubCategoryPayload = {
//     type: string;
//     categories: string[];
// };

const registrationFormSlice = createSlice({
    name: 'registrationForm',
    initialState,
    reducers: {
        setRole(state, action: PayloadAction<string>) {
            state.role = action.payload;
        },
        setUUID(state, action: PayloadAction<string>) {
            state.UUID = action.payload;
        },
        setStatus(state, action: PayloadAction<string>) {
            state.status = action.payload;
        },
        setStarterInfo(state, action: PayloadAction<StarterInfo>) {
            state.starterInfo = action.payload;
        },
        setAccountsPayableRepresentative(
            state,
            action: PayloadAction<StarterInfo>
        ) {
            state.client.accountsPayableRepresentative = action.payload;
        },
        // addTrade(state, action: PayloadAction<Trade>) {
        //     let { trades } = state.client;
        //     state.client.trades = [...trades, action.payload];
        // },
        // removeTrade(state, action: PayloadAction<string>) {
        //     let { trades } = state.client;
        //     let newTrades = trades.filter(t => t.type !== action.payload);
        //     state.client.trades = newTrades;
        // },
        // setSubCategories(state, action: PayloadAction<SubCategoryPayload>) {
        //     const { type, categories } = action.payload;
        //     let updatedTrades = state.client.trades.map(trade => {
        //         return trade.type === type
        //             ? { ...trade, subCategories: categories }
        //             : trade;
        //     });
        //     state.client.trades = updatedTrades;
        // },
        setCompanyInfo(state, action: PayloadAction<CompanyInfo>) {
            state.client.companyInfo = action.payload;
        },
        // setTeamInfo(state, action: PayloadAction<TeamInfo>) {
        //     state.client.teamInfo = action.payload;
        // },
        // setServiceArea(state, action: PayloadAction<string>) {
        //     state.client.serviceArea = action.payload;
        // },
        setDocuments(state, action: PayloadAction<ClientDocuments>) {
            state.client.documents = action.payload;
        },
        resetState(state, action: Action) {
            return initialState;
        },
    },
});

export const {
    setRole,
    setUUID,
    setStatus,
    setStarterInfo,
    setAccountsPayableRepresentative,
    // addTrade,
    // removeTrade,
    // setSubCategories,
    setCompanyInfo,
    // setTeamInfo,
    // setServiceArea,
    setDocuments,
    resetState,
} = registrationFormSlice.actions;

export default registrationFormSlice.reducer;
